var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-container"},[(_vm.$parent.data && _vm.moduleDebug)?_c('DD',{attrs:{"absolute":true,"title":_vm.$parent.data.acf_fc_layout}},[_vm._v(_vm._s(_vm.$parent.data))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }